import axios from 'axios';

class MitFavoritesService {
    constructor() {}

    get(){
        return new Promise ((resolve, reject) => {
            axios.get('/api/v1/user/favorites?returnDict=true')
               .then((response) => {
                  return resolve(response.data);
               })
               .catch((error) => {
                 console.log('ERROR:', error);
                 return reject(error);
               });
        })
    }

    delete(mitId){
        return new Promise ((resolve, reject) => {
            axios.delete('/api/v1/user/favorites/'+mitId)
               .then((response) => {
                  return resolve(response.data);
               })
               .catch((error) => {
                 console.log('ERROR:', error);
                 return reject(error);
               });
        })
    }

    save(mitId){
        return new Promise ((resolve, reject) => {
            axios.post('/api/v1/user/favorites/',{mitId:mitId})
               .then((response) => {
                  return resolve(response.data);
               })
               .catch((error) => {
                 console.log('ERROR:', error);
                 return reject(error);
               });
        })
    }
  




}
export default new MitFavoritesService();
